// 
import { get } from '../../util/requst';

export const getAuth = () => {
    return get(
        `/wxmanager/auth/auth_code/list`,
        {}

    );

};
export const logOut = () => {
    return get(
        `/wxmanager/auth/logout`,
        {}
    );
};
export const getUserinfo = () => {
    return get(
        `/wxmanager/userinfo/current`,
        {}
    );
};


export const recordChangeUser = (params:any) => {
    return get(
        `/wxmanager/userinfo/recordChangeUser`,
        params
    );
};



